/** State Management */
import { StoreProvider } from 'easy-peasy';
import React from 'react';
import ReactDOM from 'react-dom/client';

import type { EvaluationContext } from '@openfeature/web-sdk';
import { FeatureFlagProvider, initFeatureFlags } from '@submodule/featureFlags';

import './assets/styles/fonts.css';
import './assets/styles/styles.css';
import './index.css';

import App from './App';
import { AuthProvider } from './auth/AuthContext';
import store from './state/store';
import { getInitialTenantId } from './utils';

const tenantId = getInitialTenantId();
const initialFeatureFlagContext: EvaluationContext | undefined = tenantId
  ? { isAnonymous: false, targetingKey: tenantId, tenantId }
  : undefined;

initFeatureFlags(initialFeatureFlagContext);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StoreProvider store={store}>
    <AuthProvider>
      <FeatureFlagProvider
        initialApplicationContext={initialFeatureFlagContext}
      >
        <App />
      </FeatureFlagProvider>
    </AuthProvider>
  </StoreProvider>
);
